{
  "collapse": "Összecsukás",
  "expand": "Kibontás"
}
